<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand v-on:click="nav('whoami')" style="width: 20%">Nolan Shumaker $ <vue-typer :text="currentComponent" :pre-type-delay='500' :repeat="refreshCount"></vue-typer></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-on:click="nav('exp')">Work Experience</b-nav-item>
          <b-nav-item v-on:click="nav('skills')">Skills</b-nav-item>
          <b-nav-item v-on:click="nav('extra')">Extracurriculars</b-nav-item>
          <b-nav-item v-on:click="nav('hobbies')">Hobbies</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <transition name="slide-fade" mode="out-in">
      <Me :key="'me'" v-if="!currentComponent || currentComponent === 'whoami'"/>
      <Experience :key="'exp'" v-if="currentComponent === 'exp'"/>
      <SkillAreas :key="'skills'" v-if="currentComponent === 'skills'"/>
      <Hobbies :key="'hobbies'" v-if="currentComponent === 'hobbies'"/>
      <Extracurriculars :key="'Extracurriculars'" v-if="currentComponent === 'extra'"/>
    </transition>
  </div>
</template>

<script>
import Me from "@/components/Me";
import Experience from "@/components/Experience";
import SkillAreas from "@/components/SkillAreas";
import Hobbies from "@/components/Hobbies";
import Extracurriculars from "@/components/Extracurriculars";
import { VueTyper } from 'vue-typer'

export default {
  name: 'app',
  components: {
    Me,
    Experience,
    SkillAreas,
    Hobbies,
    Extracurriculars,
    VueTyper
  },
  data () {
    return {
      currentComponent: 'whoami',
      refreshCount: 0
    }
  },
  methods: {
    nav (component) {
      if (this.currentComponent === component) {
        this.refreshCount++;
      } else {
        this.refreshCount = 0;
      }
      this.currentComponent = component;
    },
    mounted () {
      this.refreshCount = 0;
    }
  }
}
</script>
